export const FETCH_LIST_ALL_MY_DELETED_TASK_REQUEST = 'FETCH_LIST_ALL_MY_DELETED_TASK_REQUEST'
export const FETCH_LIST_ALL_MY_DELETED_TASK_SUCCESS = 'FETCH_LIST_ALL_MY_DELETED_TASK_SUCCESS'
export const FETCH_LIST_ALL_MY_DELETED_TASK_FALUIRE = 'FETCH_LIST_ALL_MY_DELETED_TASK_FALUIRE'
